import Footer from "../../components/footer/Footer";
import MDAForm from "../../components/mda/mdaForm";
import MdaHeader from "../../components/mda/mdaHeader";

const GovernmentMda = () => {
    return (
        <div>
            <MdaHeader/>
            <MDAForm/>
            <Footer/>
        </div>
    )
}

export default GovernmentMda;